import React, { useEffect, useState } from 'react';

const STORAGE_KEY = 'agroshop_cookie_consent';

export default function CookieConsentBanner() {
  const [accepted, setAccepted] = useState(true);

  useEffect(() => {
    const saved = window.localStorage.getItem(STORAGE_KEY);
    if (saved !== 'accepted') {
      setAccepted(false);
    }
  }, []);

  const handleAccept = () => {
    window.localStorage.setItem(STORAGE_KEY, 'accepted');
    setAccepted(true);
  };

  if (accepted) return null;

  return (
    <div className="ag-cookie-consent">
      <div className="ag-cookie-consent__copy">
        <strong>Cookies nécessaires</strong>
        <p>
          Nous utilisons des cookies pour assurer le bon fonctionnement du site, stocker vos préférences et améliorer l’expérience.
          En poursuivant, vous acceptez l’utilisation de ces cookies.
        </p>
      </div>
      <div className="ag-cookie-consent__actions">
        <button type="button" className="ag-btn ag-btn--success" onClick={handleAccept}>
          Accepter les cookies
        </button>
      </div>
    </div>
  );
}
